import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { SupportedLocale } from '@/shared/i18n/locales';
import { localePersistenceConfig } from './config';
import { resolvePreferredLocale } from './helpers';

function getDefaultLocale(): SupportedLocale {
  return resolvePreferredLocale();
}

export interface LocaleState {
  locale: SupportedLocale;
  setLocale: (locale: SupportedLocale) => void;
}

export const useLocaleStore = create<LocaleState>()(
  persist(
    (set) => ({
      locale: getDefaultLocale(),
      setLocale: (locale) => set({ locale }),
    }),
    {
      name: localePersistenceConfig.storageKey,
      partialize: (state) => ({ locale: state.locale }),
    },
  ),
);
